module.exports = __webpack_public_path__ + "static/media/Apti_Logo.a3671bb1.svg";